/* YT hover-to-play (no chrome) */
document.addEventListener('DOMContentLoaded', () => {
  const wrappers = Array.from(document.querySelectorAll('.section-case-study-teaser .yt-hover'));
  if (!wrappers.length) return;

  const PRM = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Load the YouTube IFrame API once, on demand
  let apiLoading = false;
  let apiReady   = false;
  const onAPIReadyCallbacks = [];

  function loadYTApiOnce() {
    if (apiReady || apiLoading) return;
    apiLoading = true;
    // global callback YouTube calls when ready
    window.onYouTubeIframeAPIReady = () => {
      apiReady = true;
      onAPIReadyCallbacks.splice(0).forEach(fn => fn());
    };
    const s = document.createElement('script');
    s.src = 'https://www.youtube.com/iframe_api';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  }

  function onAPIReady(fn) {
    if (apiReady) fn();
    else onAPIReadyCallbacks.push(fn);
  }

  // One player per wrapper
  wrappers.forEach((wrap) => {
    const videoId = wrap.getAttribute('data-youtube-id');
    const playerId = wrap.getAttribute('data-player-id');
    if (!videoId || !playerId) return;

    let player = null;
    let created = false;

    // Build player lazily
    const ensurePlayer = () => {
      if (created) return;
      created = true;
      loadYTApiOnce();
      onAPIReady(() => {
        // Use youtube-nocookie for privacy
        player = new YT.Player(playerId, {
          host: 'https://www.youtube-nocookie.com',
          videoId: videoId,
          playerVars: {
            autoplay: 0,          // we’ll start via API (muted) on hover
            controls: 0,
            mute: 1,
            fs: 0,
            rel: 0,
            modestbranding: 1,
            playsinline: 1,
            iv_load_policy: 3,
            disablekb: 1,
            origin: window.location.origin
          },
          events: {
            onReady: () => {
              try { player.mute(); } catch (e) {}
              wrap.classList.add('yt-hover--ready');
            }
          }
        });
      });
    };

    const play = () => {
      if (PRM.matches) return; // respect reduced motion
      ensurePlayer();
      if (!player || typeof player.playVideo !== 'function') return;
      try { player.playVideo(); } catch (e) {}
    };

    const reset = () => {
      if (!player) return;
      try {
        player.pauseVideo();
        player.seekTo(0, true);
      } catch (e) {}
    };

    // Hover/focus handlers on the entire case-study section
    const section = wrap.closest('.section-case-study-teaser') || wrap;

    section.addEventListener('mouseenter', play);
    section.addEventListener('focusin', play);

    section.addEventListener('mouseleave', reset);
    section.addEventListener('focusout', reset);
  });
});
